import config from "@/config"
import http from "@/utils/request"

export default {
    priceDiscount: {
        getPageList: {
            url: `${config.API_URL}/api/app/price-discount/page-list`,
            name: "获取价格折扣分页数据列表",
            get: async function (params) {
                return await http.get(this.url, params);
            }
        },
        create: {
            url: `${config.API_URL}/api/app/price-discount`,
            name: "创建价格折扣",
            post: async function (params) {
                return await http.post(this.url, params);
            }
        },
        update: {
            url: `${config.API_URL}/api/app/price-discount`,
            name: "修改价格折扣",
            put: async function (params) {
                return await http.put(this.url, params);
            }
        },
        cancel: {
            url: `${config.API_URL}/api/app/price-discount/cancel`,
            name: "取消",
            post: async function (params) {
                return await http.post(this.url, params);
            }
        }
    },
    priceDiscountLog: {
        getPageList: {
            url: `${config.API_URL}/api/app/price-discount-log/page-list`,
            name: "获取价格折扣操作日志",
            get: async function (params) {
                return await http.get(this.url, params);
            }
        }
    }
}